import React from 'react';
import * as css from './TicketSeatTiles.css';
import useShrinkToFit from './useShrinkToFit';

interface SeatTileProps {
    value: string | number;
    label: string;
    flexible?: boolean;
    'data-cy'?: string;
}

function SeatTile({value, label, flexible, 'data-cy': dataCy}: SeatTileProps) {
    const ref = useShrinkToFit(String(value));

    return (
        <css.tile $flexible={flexible} data-cy={dataCy}>
            <css.valueArea>
                {flexible ? (
                    <css.blockValue ref={ref}>{value}</css.blockValue>
                ) : (
                    <css.numberValue>{value}</css.numberValue>
                )}
            </css.valueArea>
            <css.label>{label}</css.label>
        </css.tile>
    );
}

export default SeatTile;
